import {GET_SOCIETY_ACTION} from "../store";

export default {
  created: async function () {
    if (!this.$store.getters.society) {
      const loaderId = `loading_${this.$options.name}`;
      this.$wait.start(loaderId)
      await this.$store.dispatch(GET_SOCIETY_ACTION);
      this.$wait.end(loaderId);
    }
  }
};
